<template>
  <div id="app">
    <Loading></Loading>
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'app',
  components: {
    Loading,
    Header,
    Footer
  },
  metaInfo:{
    title: '360 The Content Company in El Salvador',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'We provide a high quality service, adapted to your needs and budget, helping brands to connect with consumers.'
      },
      {
        name: 'robots',
        content: 'index, follow'
      }
    ]
  },
  mounted() {
    // document.getElementById('info').remove();
  },
}
</script>

<style lang="sass">
*
  focus: none
  outline: none

::selection 
	background-color: rgba(254, 65, 61, 1)
	color: #FFF
  
body
  background: #2f2f2f

.hidden
  display: none !important

.loading
  background: #2f2f2f
  position: fixed
  display: block
  top: 0px
  left: 0px
  width: 100%
  height: 100%
  z-index: 11
  img
    position: relative
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)

#info
  font-size: 0px
  color: transparent

header
  display: block
  margin: 20px auto
  position: absolute
  left: 5%
  z-index: 11
  a
    display: block
    width: 300px
    img
      width: 100%

footer
  position: relative
  z-index: 11
  .social-media
    position: fixed
    bottom: 25px
    left: 5%
    text-align: center
    width: 40px
    a
      color: rgba(255, 255, 255, 0.7)
      font-size: 20px
      display: block
      margin-top: 20px
      &:hover
        color: rgba(255, 255, 255, 1)
    .router-link
      margin-top: 0px
      width: 130px
      -webkit-transform: rotate(-90deg)
      -moz-transform: rotate(-90deg)
      -ms-transform: rotate(-90deg)
      -o-transform: rotate(-90deg)
      transform: rotate(-90deg)
      
      -webkit-transform-origin: 7% 0%
      -moz-transform-origin: 7% 0%
      -ms-transform-origin: 7% 0%
      -o-transform-origin: 7% 0%
      transform-origin: 7% 0%

      filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3)

      font-family: 'Montserrat', sans-serif
      font-weight: 400
      letter-spacing: 2px
      font-size: 16px
      &:after
        content: ""
        display: block
        width: 50px
        height: 1px
        background: #FFF
        position: absolute
        top: 50%
        left: 100%

        transition: all 600ms cubic-bezier(0.215, 0.61, 0.355, 1) !important
        -webkit-transition: all 600ms cubic-bezier(0.215, 0.61, 0.355, 0.9) !important
        -webkit-animation-duration: 600ms !important
        animation-duration: 600ms !important
      &:hover 
        &:after
          width: 70px
  .copyright
    color: #FFF
    font-size: 14px
    letter-spacing: 2px
    font-family: 'Montserrat', sans-serif
    position: fixed
    right: 0px
    top: 0px
  .form
    display: block
    width: 100%
    overflow: hidden
    text-align: right
    position: fixed
    bottom: 0px
    right: 0px
    background: rgba(254, 65, 61, 0)
    width: 30%
    padding: 0px 5%
    min-width: 400px
    min-width: 400px
    height: 80px
    z-index: 10
    i
      color: rgba(255, 255, 255, 0.7)
      font-size: 25px
      padding: 1px
      cursor: pointer
      padding-top: 30px
      &:hover
        color: rgba(255, 255, 255, 1)
    .response
      display: block
      text-align: center
      i
        font-size: 100px
        margin-top: 40px
      h2
        display: block
        font-family: 'Montserrat', sans-serif
        font-size: 20px
        line-height: 30px
        letter-spacing: 2px
        font-weight: 300
        color: #FFF
        margin-top: 20px
        text-align: center
    .content
      display: none
      text-align: left
      h2
        display: block
        font-family: 'Montserrat', sans-serif
        font-size: 20px
        line-height: 30px
        letter-spacing: 2px
        font-weight: 300
        color: #FFF
        margin-top: 20px
        text-align: center
      input
        display: block
        width: 100%
        border: none
        padding: 10px 0px
        margin: 20px 0px
        font-family: 'Montserrat', sans-serif
        color: #FFF
        font-size: 16px
        letter-spacing: 1px
        background: transparent
        border-bottom: 1px solid rgba(255, 255, 255, 0.7)
        &::placeholder
          color: #FFF
        &:-ms-input-placeholder
          color: #FFF
        &::-ms-input-placeholder
          color: #FFF
      input[name=nelchavo]
        display: none
      textarea
        display: block
        width: 100%
        border: none
        padding: 10px 0px
        margin: 15px 0px
        font-family: 'Montserrat', sans-serif
        color: #FFF
        background: transparent
        border-bottom: 1px solid rgba(255, 255, 255, 0.7)
        font-size: 16px
        letter-spacing: 1px
        &::placeholder
          color: #FFF
        &:-ms-input-placeholder
          color: #FFF
        &::-ms-input-placeholder
          color: #FFF
      button
        width: 100px
        font-family: 'Montserrat', sans-serif
        color: #FFF
        background: transparent
        padding: 10px
        font-size: 16px
        font-weight: bold
        letter-spacing: 2px
        margin-top: 10px
        border: none        
        opacity: 0.7
        cursor: pointer
        i
          color: #FFF
          margin-left: 5px
          padding-top: 0px
          font-size: 16px
        &:hover
          opacity: 1

    &.on
      .content
        display: block
    &.on
      height: 420px
      background: rgba(254, 65, 61, 0.9)
    


.easeOutCubic 
  transition: all 600ms cubic-bezier(0.215, 0.61, 0.355, 1) !important
  -webkit-transition: all 600ms cubic-bezier(0.215, 0.61, 0.355, 0.9) !important
  -webkit-animation-duration: 600ms !important
  animation-duration: 600ms !important

#app
  height: 100vh
  width: 100vw
  background: #2f2f2f
  .home
    display: block
    height: 100%
    width: 100%
    .frame
      z-index: 9
    h1
      display: block
      font-family: 'Montserrat', sans-serif
      font-size: 2.2vw
      line-height: 3.7vw
      letter-spacing: 0.1vw
      font-weight: 300
      color: #FFF
      width: 80%
      margin: auto
      position: relative
      top: 50%
      transform: translateY(-50%)
      z-index: 10
      span
        display: block
        b
          font-weight: 600
        &:last-child
          -webkit-animation-duration: 1.2s
          animation-duration: 1.2s
          font-size: 3vw
          margin-top: 20px
          text-align: center
    .content
      display: block
      position: absolute
      top: 0px
      left: 0px
      width: 100%
      height: 100%
      visibility: hidden
      .slider-container
        display: block
        width: 100%
        height: 100%
        overflow: hidden
        position: relative
        .tns-outer
          .tns-controls
            display: none
          button
            display: none
      &.on
        visibility: visible
  .our-projects
    .content
      overflow-y: auto
      width: 90%
      margin: 0px auto 60px auto
      .title
        display: block
        width: 90%
        margin: 120px auto 40px auto
        text-align: center
        h1
          font-family: 'Montserrat', sans-serif
          font-size: 40px
          line-height: 50px
          letter-spacing: 3px
          font-weight: 300
          margin: 0px
        p
          font-family: 'Montserrat', sans-serif
          font-size: 16px
          line-height: 30px
          letter-spacing: 2px
          font-weight: 300

      .grid
        .grid__item
          // -webkit-filter: grayscale(1)
          // filter: grayscale(1)
          visibility: hidden
          a
            .description
              display: none
          &:hover
            transform: matrix3d(1,0,0.00,0,0.00,1,0.00,0.0003,0,0,1,0,0,0,0,1) !important
            -webkit-transform: matrix3d(1,0,0.00,0,0.00,1,0.00,0.0003,0,0,1,0,0,0,0,1) !important
            -webkit-filter: grayscale(0)
            filter: grayscale(0)
          &.animated
            visibility: visible
      .preview
        z-index: 9 !important
        &:before
          background: #2f2f2f
        .description
          .grid__nav
            transition-delay: 2s
            .arrow
              display: inline-block
              vertical-align: top
              padding: 10px 20px
              margin: 0px 5px
              cursor: pointer
  .reel
    .content
        overflow-y: auto
        width: 90%
        margin: 0px auto 60px auto
        .title
          display: block
          width: 90%
          margin: 120px auto 40px auto
          text-align: center
          h1
            font-family: 'Montserrat', sans-serif
            font-size: 40px
            line-height: 50px
            letter-spacing: 3px
            font-weight: 300
            margin: 0px
          p
            font-family: 'Montserrat', sans-serif
            font-size: 16px
            line-height: 30px
            letter-spacing: 2px
            font-weight: 300
        .vidio
          display: block
          margin: auto
          text-align: center
          iframe
            display: block
            margin: auto
            width: 70vw
            height: 60vh



@media(max-width:860px)
  #app
    .home
      h1
        font-size: 3.5vw
        line-height: 5vw
        position: absolute
        left: 10%
        span
          display: inline
          &:last-child
            margin-left: 8px

@media(max-width:600px)
  *
    font-weight: 400
  #app
    .home
      h1
        font-size: 8vw
        line-height: 10vw
        font-weight: 400
        left: 13%
        span
          &:last-child
            display: block
            font-size: 8vw
            line-height: 10vw
            font-weight: 400
            margin: 0px
            margin-top: 30px
            text-align: left
        b
          display: block
          font-weight: 700 !important
    
    .our-projects 
      .content
        .title
          margin: 140px auto 40px auto
          p
            font-size: 18px
        .preview
          z-index: 11 !important
          height: 100%
        .description
          height: 100%
          top: 0px
          left: 0px
          .grid__nav
            height: 100%
            .arrow
              width: 49%
              height: 100%
              margin: 0px !important
              padding: 0px !important
              i
                position: relative
                top: 50%

    
    footer
      .social-media
        z-index: 11
        .router-link
          font-weight: 500
          font-size: 17px
          width: 135px
      .form
        min-width: 100%
        max-width: 100%
        .content 
          h2
            font-weight: 400
        &.on
          z-index: 12

          



</style>
